module.exports = __webpack_public_path__ + "img/mercedes-cabanillas.1e1848c7.png";